import { render, staticRenderFns } from "./PatientDocument.vue?vue&type=template&id=7e3b937d&"
import script from "./PatientDocument.vue?vue&type=script&lang=js&"
export * from "./PatientDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports